import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: `${theme.spacing(4)} !important`,
  },
  rootActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(4),
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
  },
  rootCard: {
    marginLeft: `${theme.spacing(1)} !important`,
    marginRight: `${theme.spacing(1)} !important`,
  },
  rootContentRow: {
    display: "flex",
    flexDirection: "row",
    padding: theme.spacing(3, 2),
  },
  paper: {
    width: "100%",
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  paperWithoutWidth: {
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  btnPutList: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  textCoast: { display: "flex", alignItems: "baseline" },
  inputPhone: { marginLeft: `${theme.spacing(2)} !important` },
}));
